import * as z from 'zod/v4'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'

export const TemplateConfirmationSchema = buildEntrySchemaFor('templateConfirmation', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      ctaBanner: PrimerComponentCtaBannerSchema.optional(),
      relatedResources: z.array(PrimerComponentCardSchema).optional(),
    }),
  ),
})

export type ConfirmationPage = z.infer<typeof TemplateConfirmationSchema>
